import React, { FC, ReactElement } from 'react';
import { Pantomime } from '@page-components';

const PantomimePage: FC = (): ReactElement => {
  return <Pantomime />;
};

export default PantomimePage;
